import apiRequest from './api';

export function loginPortal(credentials, portal) {
  return apiRequest('/auth/login', {
    method: 'POST',
    body: JSON.stringify({
      ...credentials,
      portal,
    }),
  });
}

export function changePassword(token, payload) {
  return apiRequest('/auth/change-password', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export function updateProfile(token, payload) {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;

  return apiRequest('/auth/profile', {
    method: 'PATCH',
    token,
    body: isFormData ? payload : JSON.stringify(payload),
  });
}
